import React, { ChangeEvent, useEffect, useState } from 'react'

import { Icon } from '../../components/Icon'
import { Accordion, AccordionItem } from '../candidates/components/Accordion'
import UIButton from '../../components/UI/UIButton'

import UITextInput from '../../components/UI/UITextInput'

import {
  SchoolDetails,
  SchoolDetailsResponse,
  UploadResponse,
} from '../../utils/types'
import { toast } from 'react-toastify'
import { getSchool, updateSchool } from '../../api/admin/settings'
import { useQuery } from 'react-query'
import { fileUpload } from '../../api/apiService'
import Loading from '../../components/UI/Loading'

export interface password {
  oldPassword: string
  newPassword: string
}

const SchoolSettings = () => {
  const [schoolDetail, setSchoolDetail] = useState<SchoolDetails | undefined>()
  const [isUpdateLoading, setIsUpdateLoading] = useState<boolean>(false)

  const handleFileUpload = async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (file) {
      try {
        const response = (await fileUpload({
          file: file,
          category: 'user_display_pictures',
        })) as UploadResponse
        toast.success(response?.message, {
          position: 'top-right',
        })
        handleChange('logo', response?.url)
      } catch (error) {
        handleChange('logo', schoolDetail?.logo ? schoolDetail?.logo : '')
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    }
    // Reset the input field to allow selecting the same file again
    event.target.value = ''
  }

  const getSchoolData = async (): Promise<SchoolDetails> => {
    const response = (await getSchool()) as SchoolDetailsResponse
    if (response?.status != 'successful') {
      console.log('error')
    }
    return response?.data
  }

  const school = useQuery('school', getSchoolData)

  useEffect(() => {
    setSchoolDetail(school?.data)
  }, [school?.data])

  const handleChange = (fieldName: string, value: string) => {
    setSchoolDetail((prevValues: SchoolDetails | undefined) => {
      if (!prevValues) return prevValues // Return undefined if prevValues is undefined
      return {
        ...prevValues,
        [fieldName]: value,
      }
    })
  }

  const UpdataSchoolData = async (values: SchoolDetails): Promise<void> => {
    setIsUpdateLoading(true)
    try {
      const response = (await updateSchool(values)) as {
        status?: string
        data: SchoolDetails
      }
      if (response?.status == 'successful') {
        school.refetch()
        toast.success('Profile Updated.', {
          position: 'top-right',
        })
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      toast.error(
        'Please make sure all fields are filled correctly before updating.',
        { position: 'top-right' }
      )
    } finally {
      setIsUpdateLoading(false)
    }
  }

  return (
    <div
      style={{
        height: 'calc(100vh - 100px)',
        overflow: 'auto',
        scrollbarWidth: 'none',
      }}
    >
      <div className="flex my-8 gap-2">
        {/* First column */}
        {school.isLoading ? (
          <div className="flex justify-center items-center h-screen w-full">
            <Loading size="large" />
          </div>
        ) : (
          <div className="flex flex-col w-8/12 gap-4">
            <Accordion defaultActiveIndex={0}>
              <AccordionItem
                onClick={() => console.log('Accordion')}
                title={'School Name 1'}
                isActive={false}
              >
                <div className="flex flex-col gap-4 mt-2 my-4 px-2">
                  {schoolDetail?.logoUrl != '' ? (
                    <div className="flex w-full items-center gap-4">
                      <img
                        src={
                          schoolDetail?.logoUrl == 'https:www.logo.com/logo'
                            ? '/Squircle22.png'
                            : schoolDetail?.logoUrl == ''
                              ? '/Squircle22.png'
                              : schoolDetail?.logoUrl
                        }
                        width={150}
                        height={110}
                        className="rounded-lg"
                      />
                      <label htmlFor="fileInput">
                        <div className="rounded-[72px] bg-gray2 py-3 px-4 flex items-center gap-1 cursor-pointer">
                          <Icon
                            name="IconRefresh"
                            width={16}
                            height={16}
                            strokeWidth={1}
                            stroke={'#67A5B9'}
                          />
                          <p
                            className={
                              'text-text1 font-medium text-xs leading-5'
                            }
                          >
                            Change Logo
                          </p>
                          <input
                            id="fileInput"
                            type="file"
                            onChange={handleFileUpload}
                            style={{ display: 'none' }}
                            accept={
                              '.pdf, .doc, .docx, .jpg, .jpeg, .png, .svg'
                            }
                          />
                        </div>
                      </label>
                      <div
                        onClick={() => {
                          handleChange('logo', '')
                        }}
                        className="bg-transparent border border-textError rounded-[72px] py-3 px-4 flex items-center gap-1 cursor-pointer"
                      >
                        <Icon
                          name="IconTrash"
                          width={16}
                          height={16}
                          strokeWidth={1}
                          stroke={'#FF6666'}
                        />
                        <p className="text-textError font-medium text-xs leading-5">
                          Delete
                        </p>
                      </div>
                    </div>
                  ) : (
                    <div className="flex w-full items-center gap-4">
                      <div className="flex justify-center items-center bg-bluishGreen w-[150px] h-[110px] rounded-2xl">
                        <Icon
                          name="IconBuilding"
                          width={24}
                          height={24}
                          strokeWidth={1.5}
                          stroke={'#FFFFFF'}
                        />
                      </div>
                      <label htmlFor="fileInput">
                        <div className="rounded-[72px] bg-gray2 py-3 px-4 flex items-center gap-1 cursor-pointer">
                          <Icon
                            name="IconPlus"
                            width={16}
                            height={16}
                            strokeWidth={1.2}
                            stroke={'#02698C'}
                          />
                          <p
                            className={
                              'text-text1 font-medium text-xs leading-5'
                            }
                          >
                            Add School logo
                          </p>
                          <input
                            id="fileInput"
                            type="file"
                            onChange={handleFileUpload}
                            style={{ display: 'none' }}
                            accept={
                              '.pdf, .doc, .docx, .jpg, .jpeg, .png, .svg'
                            }
                          />
                        </div>
                      </label>
                    </div>
                  )}
                  <div className="flex w-full">
                    <p className="text-text1 font-medium text-xs leading-5">
                      Your school logo should be 100px and no bigger than 5 mb
                    </p>
                  </div>
                  <div className="flex w-full">
                    <div className="w-6/12">
                      <div className="mr-2">
                        <UITextInput
                          label={'School Name'}
                          placeholder="School Name"
                          value={schoolDetail?.name}
                          onChange={(e) => {
                            handleChange('name', e.target.value)
                          }}
                          iconName={''}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="flex w-full gap-4">
                    <div className="w-6/12  ">
                      <UITextInput
                        label={'Address Line 1'}
                        placeholder="Address Line 1"
                        value={schoolDetail?.addressLineOne}
                        onChange={(e) => {
                          handleChange('addressLineOne', e.target.value)
                        }}
                        iconName={''}
                      />
                    </div>
                    <div className="w-6/12">
                      <UITextInput
                        label={'Address Line 2'}
                        placeholder="(Optional)"
                        value={schoolDetail?.addressLineTwo}
                        onChange={(e) => {
                          handleChange('addressLineTwo', e.target.value)
                        }}
                        iconName={''}
                      />
                    </div>
                  </div>
                  <div className="flex w-full gap-4">
                    <div className="w-6/12 ">
                      <UITextInput
                        label={'Town'}
                        placeholder="Town"
                        value={schoolDetail?.town ? schoolDetail?.town : ''}
                        onChange={(e) => {
                          handleChange('town', e.target.value)
                        }}
                        iconName={''}
                      />
                    </div>
                    <div className="w-6/12">
                      <UITextInput
                        label={'Country'}
                        placeholder="Country"
                        value={
                          schoolDetail?.country ? schoolDetail?.country : ''
                        }
                        onChange={(e) => {
                          handleChange('country', e.target.value)
                        }}
                        iconName={''}
                      />
                    </div>
                  </div>
                  <div className="flex w-full">
                    <div className="w-6/12">
                      <div className="mr-2">
                        <UITextInput
                          label={'Postcode'}
                          placeholder="Postcode"
                          value={
                            schoolDetail?.postcode ? schoolDetail?.postcode : ''
                          }
                          onChange={(e) => {
                            handleChange('postcode', e.target.value)
                          }}
                          iconName={''}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </AccordionItem>
            </Accordion>
          </div>
        )}
      </div>
      <div className="bg-gray3 w-full h-[1px] my-3"></div>
      <div className="w-[33%] mt-6">
        <UIButton
          loading={isUpdateLoading}
          label="Update"
          onClick={() => {
            if (schoolDetail) UpdataSchoolData(schoolDetail)
          }}
        />
      </div>
    </div>
  )
}

export default SchoolSettings
